import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=3bad361b&scoped=true&"
import script from "./privacyAgreement.vue?vue&type=script&lang=js&"
export * from "./privacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=3bad361b&lang=scss&scoped=true&"
import style1 from "./privacyAgreement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad361b",
  null
  
)

export default component.exports